{
	"error": "Error!",
	"success": "Éxito!",
	"warning": "Atención!"
}
